import React from 'react';
import ReactDOM from 'react-dom';
import Checkout from './Checkout';

const htmlElement = document.querySelector('#checkout-container');
const productCode = htmlElement.getAttribute('data-product-code');
const productCodeType = htmlElement.getAttribute('data-product-code-type');
const stripeApiKey = htmlElement.getAttribute('data-stripe-api-key');

ReactDOM.render(<Checkout productCode={productCode}
                          productCodeType={productCodeType}
                          stripeApiKey={stripeApiKey} />, htmlElement);
